import { post, getData } from "../lib/request";

export const createUser = async (
  name,
  email,
  password,
  password_confirmation,
  affiliate,
  ref,
  banner
) => {
  try {
    const response = await post("/signup", {
      signup: {
        name,
        email,
        password,
        password_confirmation,
        affiliate,
        ref,
        banner
      }
    });
    return response.data;
  } catch (error) {
    return error.response && error.response.status === 422
      ? "Email is already taken."
      : "Unknown error. Please try again";
  }
};

export const getCurrentUser = jwt => {
  return getData(`/user`, jwt);
};

export const getPlan = (jwt, planId, source) => {
  return getData(`/get_plan?plan=${planId}&source=${source}&getuser`, jwt);
};

export const getAccountInfo = jwt => {
  return getData(`/account_info?getuser`, jwt);
};

export const getAffiliate = jwt => {
  return getData(`/affiliate?getuser`, jwt);
};

export const getUserFiles = jwt => {
  return getData("/drafts?getuser", jwt);
};

export const getIntegrations = (jwt, slug) => {
  if (slug) {
    return getData(`/integration/${slug}?getuser`, jwt);
  }
  return getData(`/integrations?getuser`, jwt);
};



// WEBPACK FOOTER //
// ./src/services/userApi.js